import script from "./FoundryContractSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FoundryContractSection.vue?vue&type=script&setup=true&lang=js"

import "./FoundryContractSection.vue?vue&type=style&index=0&id=4d8e016f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d8e016f"]])

export default __exports__